import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { DataBlocks, I18n, Icon, Button, Heading } from 'components';

import { openPopup } from 'actions';

import classNames from 'classnames/bind';
import MulticonvergenceOfferPopup from '../../components/MulticonvergenceOfferPopup';
import { SET_ALLINONE_VALUE } from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const MulticonvergenceOfferPlane = (props) => {
  const {
    offerTitle,
    offerDescription,
    isAvailableMultiConvergence,
    actions,
    setDefaultRegion,
    resetPopupData,
  } = props;
  const [isShowPlane, setIsShowPlane] = useState(isAvailableMultiConvergence);
  const [isPopupOpened, setIsPopupOpened] = useState(false);

  useEffect(() => {
    setIsShowPlane(isAvailableMultiConvergence);
  }, [isAvailableMultiConvergence]);

  const getRegion = () => {
    const regionTitle = document.querySelector('meta[name="REGION_TITLE"]');
    const regionID = document.querySelector('meta[name="REGION_ID"]');
    return {
      id: regionID ? regionID.content : 98140,
      label: regionTitle ? regionTitle.content : 'Москва',
    };
  };

  const handleClose = () => {
    setIsShowPlane(false);
    setIsPopupOpened(true);
  };

  const handleClick = () => {
    const { id, label } = getRegion();

    setIsPopupOpened(true);

    actions.openPopup('multiconvergenceOfferConnectionRequest');

    setDefaultRegion(id, label);
  };

  const handleClosePopup = () => {
    resetPopupData();
    setIsPopupOpened(false);
  };

  if (!isShowPlane) {
    return null;
  }

  return (
    <>
      <MulticonvergenceOfferPopup
        isOpened={isPopupOpened}
        closePopup={handleClosePopup}
      />
      <DataBlocks.Block className="attention" ariaLabel="Внимание!">
        <DataBlocks.Table>
          <DataBlocks.TableRow className={cx('planeTableRow')}>
            <DataBlocks.TableCell>
              <Heading className={cx('planeTitle')}>
                <I18n
                  path="home.multiconvergenceOffer.offerTitle"
                  vars={{ title: offerTitle }}
                />
              </Heading>
            </DataBlocks.TableCell>
            <DataBlocks.TableCell className={cx('iconsCell')}>
              <button
                className={cx('iconButton')}
                onClick={() => handleClose()}
                type="button"
              >
                Закрыть
                <Icon className={cx('crossIcon')} name="cross" />
              </button>
            </DataBlocks.TableCell>
          </DataBlocks.TableRow>
          <DataBlocks.TableRow className={cx('planeTableRow')}>
            <DataBlocks.TableCell colSpan="2">
              <div>
                <I18n
                  path="home.multiconvergenceOffer.offerDescription"
                  vars={{ description: offerDescription }}
                />
              </div>
            </DataBlocks.TableCell>
          </DataBlocks.TableRow>
          <DataBlocks.TableRow className={cx('planeTableRow')}>
            <DataBlocks.TableCell colSpan="2">
              <Button className="default" onClick={() => handleClick()}>
                <I18n path="home.multiconvergenceOffer.acceptOfferButton" />
              </Button>
            </DataBlocks.TableCell>
          </DataBlocks.TableRow>
        </DataBlocks.Table>
      </DataBlocks.Block>
    </>
  );
};

MulticonvergenceOfferPlane.propTypes = {
  isAvailableMultiConvergence: PropTypes.bool,
  offerTitle: PropTypes.string,
  offerDescription: PropTypes.string,
  actions: PropTypes.object,
  resetPopupData: PropTypes.func.isRequired,
  setDefaultRegion: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { multiconvergenceOffer } = state?.home?.profileSummary?.data || {};

  return {
    isAvailableMultiConvergence:
      multiconvergenceOffer?.isAvailableMultiConvergence,
    offerTitle: multiconvergenceOffer?.offerTitle,
    offerDescription: multiconvergenceOffer?.offerDescription,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetPopupData: () => {
      dispatch({
        type: SET_ALLINONE_VALUE,
        payload: {
          requestData: {},
        },
      });
    },
    setDefaultRegion: (id, label) => {
      dispatch({
        type: SET_ALLINONE_VALUE,
        payload: {
          region: {
            id,
            label,
          },
        },
      });
    },
    actions: bindActionCreators(
      {
        openPopup,
      },
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MulticonvergenceOfferPlane);
